import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Button, Table } from 'reactstrap';
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useNavigate } from "react-router-dom";

const FetchRepos = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [userMetadata, setUserMetadata] = useState(null);
  const [folders, setFolders] = useState(null);
  const [repos, setRepos] = useState(null);
  const [reposPath, setReposPath] = useState(null);
  const [currentPath, setCurrentPath] = useState("");
  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);

  const location = useLocation();
  let navigate = useNavigate();

  let fetchPath = "";
      if(location.hash) {
        fetchPath = location.hash.substring(1);
      }

  function handleFolderClick(newPath) {
    //navigate('')
    //console.log("Handle click to: " + location.hash);
    console.log("Handle click to: " + newPath);
    console.log("Current path=" + location.hash);
    //setCurrentPath(location.hash);
    //setCurrentPath(newPath);
  }

  //const accessToken = useAccessToken(`https://hem.fomalhaut.se/repo-list-server-context-root/repo-list-server-application-path/rest/v1/`);

  // useEffect(() => {
  //   const getUserMetadata = async () => {
  //     const domain = "dev-6rt7-h43.eu.auth0.com";
  
  //     try {
  //       const accessToken = await getAccessTokenSilently({
  //         audience: `https://${domain}/api/v2/`,
  //         scope: "read:current_user",
  //       });
  
  //       const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}`;
  
  //       const metadataResponse = await fetch(userDetailsByIdUrl, {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       });
  
  //       const { user_metadata } = await metadataResponse.json();
  
  //       setUserMetadata(user_metadata);
  //     } catch (e) {
  //       console.log(e.message);
  //     }
  //   };
  
  //   getUserMetadata();
  // }, [getAccessTokenSilently, user?.sub]);

  const getAccessToken = useCallback(async () => {
    if(accessToken) {
      return accessToken;
    }

    const myAT = await getAccessTokenSilently({
      audience: `https://hem.fomalhaut.se/repo-list-server-context-root/repo-list-server-application-path/rest/v1/`,
    });

    setAccessToken(myAT);
    return myAT;
  }, [accessToken, getAccessTokenSilently]);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BACK_END_HOST_URL;
  
    console.log("Fetching token silently");
    getAccessToken().then((accessToken) => {

      console.log("Fetched access token: " + accessToken);
      console.log("HASH is " + location.hash);
      
      console.log("Fetching folders in " + fetchPath);
      const rootFoldersUrl = `${baseUrl}/repo-list-server-application-path/rest/v1/folders/` + fetchPath;
      axios.get(rootFoldersUrl, {
        headers: {
          'X-JWT-Assertion': `${accessToken}`,
        },
      }).then((rootFoldersResponse) => {
          console.log("Successfully called: " + rootFoldersResponse.data);
          const {folders, path} = rootFoldersResponse.data;
          folders.forEach((x) => {
            const { displayName } = x;
            console.log("Folder: " + displayName);
          });

          //setReposPath(path);
          setFolders(folders);

          console.log("Fetching repos in " + location.hash);
          const rootReposUrl = `${baseUrl}/repo-list-server-application-path/rest/v1/repos/` + fetchPath;
          axios.get(rootReposUrl, {
            headers: {
              'X-JWT-Assertion': `${accessToken}`,
            },
          }).then((rootReposResponse) => {
              console.log("Successfully called: " + rootReposResponse.data);
              const {repos, path} = rootReposResponse.data;
              repos.forEach((x) => {
                const { displayName, cloneCmd } = x;
                console.log("Repo: " + displayName + ", clone: " + cloneCmd);
              });

              setReposPath(path);
              setRepos(repos);

              //setUserMetadata(repos);
            }).catch(error => {
                setError(error);
              });
        }).catch(error => {
            setError(error);
          });
    });
  }, [getAccessToken, user?.sub, currentPath, location.hash]);

  if(error) return(
    <div>
      <p>An error occured while fetching repos: "{error.message}"</p>
    </div>
  )

  return (
    isAuthenticated && (
      <div>
        <h5>Repos in folder: {reposPath}</h5>
        <Table>
          <thead>
            <tr>
              <th>
                Name
              </th>
              <th>
                Last Modified
              </th>
            </tr>
          </thead>
          <tbody>
            { folders? folders.map(folder => {
                const subPath = (fetchPath.length === 0? folder.displayName : fetchPath + "/" + folder.displayName);
                //const subPath = fetchPath + "/" + folder.displayName;
                //const subPath2 = "#" + fetchPath + "/" + folder.displayName;
                const subPath2 = "#" + subPath;
                return (<tr>
                  <td><a href={subPath2} onClick={handleFolderClick(subPath)}>{folder.displayName}</a></td>
                  <td>{(new Date(folder.lastModified)).toLocaleDateString("sv-SV", { hour: "2-digit", minute: "2-digit", second: "2-digit"})}</td>
                </tr>)
              })
              :
              (
                <tr>
                  <td>-</td>
                  <td>-</td>
                </tr>
              )
            }
          </tbody>
        </Table>
        <Table>
          <thead>
            <tr>
              <th>
                Name
              </th>
              <th>
                Last modified
              </th>
              <th>
                Clone command
              </th>
            </tr>
          </thead>
          <tbody>
            { repos? repos.map(repo => (
                <tr>
                  <td>{repo.displayName}</td>
                  <td>{(new Date(repo.lastModified)).toLocaleDateString("sv-SV", { hour: "2-digit", minute: "2-digit", second: "2-digit"})}</td>
                  <td>{repo.cloneCmd}</td>
                </tr>
              ))
              :
              (
                <tr>
                  <td>-</td>
                  <td>-</td>
                </tr>
              )
            }
          </tbody>
        </Table>

        <Button color="danger">Boost button!</Button>
      </div>
    )
  );
};

export default FetchRepos;